import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { base_url } from "../../server";

function EarningPoints() {
  const userid = window.localStorage.getItem("user_id");
  const [data, setData] = useState();
  const baseUrl = base_url();
  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}clubPointsUser/public/${userid}`);
      setData(res.data);
    } catch (error) {
      alert("Server Error Failed To load Data");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section className="sectionPD">
      <div className="container">
        <div className="fisherman-content">
          <h3>My Points</h3>
        </div>
        <div className="row ">
          <div className="col-md-12 mb-3">
            <div className="bgGray rounded overflow-hidden">
              <div className="px-3 pt-3 pb-3">
                <div className="h3 fw-700">
                  {data?.Points} Points = ₹1.00 Wallet Money
                </div>
                <div>Exchange Rate</div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="fisherman-content">
              <h3>Point Earning history</h3>
            </div>
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Order Code</th>
                    <th>Points</th>
                    <th>Product Qty</th>
                    <th>Type</th>
                    <th>Date</th>
                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data?.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{item?.order_id?.order_referenceNo}</td>
                          <td>{item?.point}</td>
                          <td>{item?.product_qty}</td>
                          <td>@mdo</td>
                          <td>@mdo</td>
                          {/* <td>@mdo</td> */}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default EarningPoints;
